module.exports = __webpack_public_path__ + "static/media/quicky-backpack.d95da0da.png";